'use client';

import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import FareRule from './fareRule';

interface AccordionProps {
  data: any;
  fareRules: unknown;
  isLoader: boolean;
}

function AccordionTab({ data, fareRules, isLoader }: AccordionProps) {
  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value="item-1">
        <AccordionTrigger>
          <div className="flex w-full flex-1 items-center justify-between px-1 md:px-2">
            <div className="flex flex-row items-center gap-1 md:gap-2">
              <h5 className="max-w-[200px] break-words text-[11px] font-medium md:max-w-none md:text-xs">
                {`${data?.flightInfo?.[0]?.departure_city_name} - ${data?.flightInfo?.[0]?.arrival_city_name}`}
              </h5>
            </div>
            <div
              className={`ml-2 rounded-lg px-1.5 py-0.5 text-[10px] md:ml-4 md:px-2 md:py-1 md:text-xs ${
                data?.price_details[0]?.refundableType.toLowerCase() ===
                'refundable'
                  ? 'bg-green-50 text-green-600'
                  : 'bg-red-50 text-red-500'
              }`}
            >
              {data?.price_details[0]?.refundableType}
            </div>
          </div>
        </AccordionTrigger>
        <AccordionContent className="px-2 md:px-1">
          <FareRule fareRules={fareRules} isLoader={isLoader} />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

export default AccordionTab;
